import './about.css'
import ME from '../../assets/ME.png'
import {FaPaintBrush} from 'react-icons/fa'
import {BiCodeBlock} from 'react-icons/bi'
import {AiFillDatabase} from 'react-icons/ai'
import { motion } from 'framer-motion';
import { useInView } from "react-intersection-observer";
function About() {
  const [ref, inView] = useInView({
    triggerOnce: true,
  });
  return (
    <section id='about'>
      <motion.h5  
      whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",
      }}>Get to know</motion.h5>
      <motion.h2 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",delay:0.3
      }}>About Me</motion.h2>
      <div className="container about_container">
        <div className="about_me">
          <div className="about_me_image">
            <img src={ME} alt="error" />
          </div>
        </div>
        <div className="about_content">
          <div className="about_cards" ref={ref}>
            <motion.article
            initial={{ opacity: 0}}
            animate={inView ? { opacity: 1}:{ opacity: 0}}
      transition={{
        delay:1*0.5,type: "spring",ease: "easeOut",duration:0.75
      }} className="about_card">
              <FaPaintBrush className='about_card_icon' />
              <h5>UI/UX designing</h5>
              {/* <small>3+ Years Working</small> */}
            </motion.article>
            <motion.article 
            initial={{ opacity: 0}}
            animate={inView ? { opacity: 1}:{ opacity: 0}}
      transition={{
        delay:2*0.5,type: "spring",ease: "easeOut",duration:0.75
      }} className="about_card">
              <BiCodeBlock className='about_card_icon' />
              <h5>Frontend Development</h5>
              {/* <small>3+ Years Working</small> */}
            </motion.article>
            <motion.article 
            initial={{ opacity: 0}}
            animate={inView ? { opacity: 1}:{ opacity: 0}}
      transition={{
        delay:3*0.5,type: "spring",ease: "easeOut",duration:0.75
      }} className="about_card">
              <AiFillDatabase className='about_card_icon' />
              <h5>Backend Development</h5>
              {/* <small>3+ Years Working</small> */}
            </motion.article>
          </div>
          <p>
          My name's Dhanush Saji. I'm a full-stack web-developer based in Masai School, Benguluru.<br></br>
          I'm experienced in building scalable web applications with the MERN stack. With a Btech in Computer Science and UI/UX design experience, I have a strong foundation in designs. Because I was interested in bringing my designs to life, I enrolled in a Full Stack Web Development course at Masai School, where I gained hands-on experience with the MERN stack, data structures, and algorithms. I developed soft skills, including effective communication and time management, which, combined with my technical skills, make me well-equipped to develop high-quality web applications. As an ambitious developer, I am passionate about enhancing my skills, learning new technologies, and contributing to organizational growth. Besides coding, I am a singer and guitarist, which reflects my creative side.
          </p>
        </div>
      </div>
    </section>
  )
}

export default About